import Intro from './Intro';
import Grid from '../../common/Grid';
import MyPolices from './MyPolices';
import Profile from './Profile';
import NoPayPolices from './NoPayPolices';
import { useParams } from 'react-router-dom';
import { useFetch } from '../../../hooks/useFetch';
import LoadingSmall from '../../common/LoadingSmall';

export const ClientDashId = () => {
	const { id } = useParams();

	const { data, isLoading } = useFetch(`user/${id}`);

	return (
		<>
			{isLoading ? <LoadingSmall /> : <Intro user={data} />}
			<Grid
				columns="2"
				margin="0 0 50px 0"
				justify="strech">
				{isLoading ? (
					<div>Loading...</div>
				) : (
					<>
						<Profile userId={data} />
						<MyPolices id={id} />
					</>
				)}
			</Grid>
			{isLoading ? <div>Loading...</div> : <NoPayPolices id={id} />}
		</>
	);
};
